/**
 * AIF-03 — FE role-gating for the Import-AI-Findings wizard.
 *
 * Per `.vibe/23` §6 (MM3) + the contract op descriptions, running an import is
 * gated server-side to `expert_analyst`, `tenant_admin`, `platform_admin`. The
 * server is the security boundary (403 on a write without the role); this hook
 * is the UX nicety so an ineligible user is redirected away from the page
 * rather than being allowed to fill the wizard and fail at the final POST.
 *
 * Same shape + role set as AIF-01's `useAiModelWritePermissions`; kept as a
 * dedicated hook so the import gate can diverge later if the role matrix does.
 */
import { useHasRole } from "@aeriosiq/auth-client";

export interface ImportPermissions {
  /** May run the import (analyze + execute). */
  canImport: boolean;
}

export function useImportPermissions(): ImportPermissions {
  const isTenantAdmin = useHasRole("tenant_admin");
  const isExpertAnalyst = useHasRole("expert_analyst");
  const isPlatformAdmin = useHasRole("platform_admin");
  return { canImport: isTenantAdmin || isExpertAnalyst || isPlatformAdmin };
}
